import { render } from "./RMTable.vue?vue&type=template&id=35f57296&scoped=true"
import script from "./RMTable.vue?vue&type=script&lang=js"
export * from "./RMTable.vue?vue&type=script&lang=js"

import "./RMTable.vue?vue&type=style&index=0&id=35f57296&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f57296"]])

export default __exports__